import { c as _c } from "react/compiler-runtime";
import { Box, Stack, Typography } from '@mui/material';
import { ConditionOperatorEnum } from '@repo/api-gw-sdk';
import { useMemo, useState } from 'react';
import { AddButton } from '@/components/buttons/addButton';
import { SelectionPanel } from '@/components/panels/selectionPanel/selectionPanel';
import { SearchTextBox } from '@/components/search/searchTextBox';
import { createCombineCondition, isValueCondition, PropertyType } from '@/types/advanceFilter';
import type { TagsDataResult, TagsFilterProps } from './tagsFilter';
import { useResourceTagsData, useSourceAccountTagsData } from './tagsFilter';
import { MultiSelectFilter } from '../filters';
import { cloudProvider } from '../properties';
function useProviderFilter(props) {
  const $ = _c(2);
  let t0;
  bb0: {
    if (!props.supportedProviders?.length) {
      t0 = undefined;
      break bb0;
    }
    let t1;
    if ($[0] !== props.supportedProviders) {
      t1 = createCombineCondition([{
        property: cloudProvider.name,
        operator: ConditionOperatorEnum.In,
        value: props.supportedProviders
      }]);
      $[0] = props.supportedProviders;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  return t0;
}
const ResourceTagsConditionWrapper = props => {
  const $ = _c(3);
  const filter = useProviderFilter(props);
  const tagsData = useResourceTagsData(filter);
  let t0;
  if ($[0] !== props || $[1] !== tagsData) {
    t0 = <TagsConditionContent {...props} tagsData={tagsData} />;
    $[0] = props;
    $[1] = tagsData;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
const SourceAccountTagsConditionWrapper = props => {
  const $ = _c(3);
  const filter = useProviderFilter(props);
  const tagsData = useSourceAccountTagsData(filter);
  let t0;
  if ($[0] !== props || $[1] !== tagsData) {
    t0 = <TagsConditionContent {...props} tagsData={tagsData} />;
    $[0] = props;
    $[1] = tagsData;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export const TagsCondition = props => {
  const $ = _c(4);
  if (props.dataSource === "sourceAccountTags") {
    let t0;
    if ($[0] !== props) {
      t0 = <SourceAccountTagsConditionWrapper {...props} />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <ResourceTagsConditionWrapper {...props} />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
const TagsConditionContent = props => {
  const $ = _c(66);
  const [keyFilter, setKeyFilter] = useState("");
  const [valueFilter, setValueFilter] = useState("");
  const [isScrolledVertically, setScrolledVertically] = useState(false);
  const {
    data: body,
    isLoading
  } = props.tagsData;
  let t0;
  if ($[0] !== props.conditions || $[1] !== props.property) {
    let t1;
    if ($[3] !== props.property) {
      t1 = x => isValueCondition(x) && x.property === props.property.name;
      $[3] = props.property;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = props.conditions.find(t1);
    $[0] = props.conditions;
    $[1] = props.property;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const condition = t0;
  let t1;
  if ($[5] !== condition) {
    t1 = isValueCondition(condition) && condition?.value || [];
    $[5] = condition;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const selectedResources = t1;
  let t2;
  if ($[7] !== body?.tags) {
    t2 = body?.tags || [];
    $[7] = body?.tags;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const tags = t2;
  selectedResources.forEach(tag => {
    const [key, value] = tag.split("=");
    if (!tags.some(t => t.key === key && t.value === value)) {
      tags.push({
        key,
        value
      });
    }
  });
  const allTags = tags;
  let t3;
  if ($[9] !== allTags) {
    t3 = allTags.reduce(_temp, {
      keys: new Set(),
      values: new Set()
    });
    $[9] = allTags;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const tagsReduced = t3;
  let t4;
  if ($[11] !== keyFilter || $[12] !== tagsReduced.keys) {
    t4 = Array.from(tagsReduced.keys).filter(key_0 => !keyFilter || key_0.toLowerCase().includes(keyFilter.toLowerCase())).map(_temp2);
    $[11] = keyFilter;
    $[12] = tagsReduced.keys;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const keys = t4;
  let t5;
  if ($[14] !== tagsReduced.values || $[15] !== valueFilter) {
    t5 = Array.from(tagsReduced.values).filter(value_0 => !valueFilter || value_0.toLowerCase().includes(valueFilter.toLowerCase())).sort().map(_temp3);
    $[14] = tagsReduced.values;
    $[15] = valueFilter;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const values = t5;
  let t6;
  if ($[17] !== allTags || $[18] !== keyFilter || $[19] !== valueFilter) {
    let t7;
    if ($[21] !== keyFilter || $[22] !== valueFilter) {
      t7 = t_0 => (!keyFilter || t_0.key.toLowerCase().includes(keyFilter.toLowerCase())) && (!valueFilter || !!t_0.value?.toLowerCase().includes(valueFilter.toLowerCase()));
      $[21] = keyFilter;
      $[22] = valueFilter;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    const allValues = Array.from(new Set(allTags.filter(t7).map(_temp4)));
    t6 = allValues.map(_temp5);
    $[17] = allTags;
    $[18] = keyFilter;
    $[19] = valueFilter;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const keyValuePairs = t6;
  const filteredValue = props.initialFilterMode === "key" ? keyFilter : props.initialFilterMode === "value" ? valueFilter : `${keyFilter}=${valueFilter}`;
  const options = props.initialFilterMode === "key" ? keys : props.initialFilterMode === "value" ? values : keyValuePairs;
  let t7;
  if ($[24] !== props || $[25] !== selectedResources) {
    t7 = item => {
      const values_0 = selectedResources.filter(x_1 => x_1 !== item);
      const existingCondition = props.conditions.find(x_2 => isValueCondition(x_2) && x_2.property === props.property.name);
      props.onChange(props.conditions.filter(x_3 => x_3 !== existingCondition).concat(values_0.length ? [{
        property: props.property.name,
        operator: existingCondition ? existingCondition.operator : props.property.type === PropertyType.MultipleValues ? ConditionOperatorEnum.ContainsAnyOf : ConditionOperatorEnum.In,
        value: values_0
      }] : []));
    };
    $[24] = props;
    $[25] = selectedResources;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== condition || $[28] !== props) {
    t8 = () => props.onChange(props.conditions.filter(x_4 => x_4 !== condition));
    $[27] = condition;
    $[28] = props;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== selectedResources || $[31] !== t7 || $[32] !== t8) {
    t9 = {
      items: selectedResources,
      entityType: "tag",
      onRemove: t7,
      renderItem: _temp6,
      itemKey: _temp7,
      clearAll: t8
    };
    $[30] = selectedResources;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  const t10 = isScrolledVertically ? "var(--mui-customShadows-panel)" : undefined;
  let t11;
  if ($[34] !== t10) {
    t11 = {
      gap: "12px",
      borderBottom: "1px solid var(--mui-palette-divider)",
      boxShadow: t10
    };
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const t12 = `Select one or more ${props.initialFilterMode}${props.initialFilterMode === "key" ? "s" : " pairs"}.`;
  let t13;
  if ($[36] !== t12) {
    t13 = <Typography className="my-[12px]" variant="body1">{t12}</Typography>;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== filteredValue || $[39] !== keyFilter || $[40] !== props || $[41] !== selectedResources || $[42] !== valueFilter) {
    t14 = (props.initialFilterMode.includes("key") || props.initialFilterMode.includes("value")) && <Stack direction="row" className="w-full" sx={{
      alignItems: "center",
      gap: "12px"
    }}><Stack sx={{
        gap: "12px",
        flexGrow: 1
      }}>{props.initialFilterMode.includes("key") && <SearchTextBox value={keyFilter} onChange={setKeyFilter} placeholder="Search by key" />}{props.initialFilterMode.includes("value") && <SearchTextBox value={valueFilter} onChange={setValueFilter} placeholder="Search by value" />}</Stack><AddButton disabled={selectedResources.includes(filteredValue) || props.initialFilterMode === "key" && !keyFilter || props.initialFilterMode === "value" && !valueFilter || props.initialFilterMode === "key-value" && !keyFilter} onClick={() => {
        const values_1 = [...selectedResources, filteredValue];
        const existingCondition_0 = props.conditions.find(x_5 => isValueCondition(x_5) && x_5.property === props.property.name);
        props.onChange(props.conditions.filter(x_6 => x_6 !== existingCondition_0).concat(values_1.length ? [{
          property: props.property.name,
          operator: existingCondition_0 ? existingCondition_0.operator : props.property.type === PropertyType.MultipleValues ? ConditionOperatorEnum.ContainsAnyOf : ConditionOperatorEnum.In,
          value: values_1
        }] : []));
      }} /></Stack>;
    $[38] = filteredValue;
    $[39] = keyFilter;
    $[40] = props;
    $[41] = selectedResources;
    $[42] = valueFilter;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t11 || $[45] !== t13 || $[46] !== t14) {
    t15 = <Stack className="px-[24px] pb-[24px] py-[12px]" sx={t11}>{t13}{t14}</Stack>;
    $[44] = t11;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
  } else {
    t15 = $[47];
  }
  let t16;
  if ($[48] !== isScrolledVertically) {
    t16 = event => {
      const target = event.target as HTMLDivElement;
      if (typeof target.scrollTop === "number") {
        const isScrolled = target.scrollTop > 0;
        if (isScrolled !== isScrolledVertically) {
          setScrolledVertically(isScrolled);
        }
      }
    };
    $[48] = isScrolledVertically;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      flexGrow: 1
    };
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== options.length) {
    t18 = options.length === 0 && <Typography variant="body1" className="my-[12px]">{"No matching values found. Try a new search term, or add this value manually to include it once it's discovered."}</Typography>;
    $[51] = options.length;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== options || $[54] !== props || $[55] !== selectedResources.length) {
    t19 = options.length > 0 && <MultiSelectFilter {...props} options={options} virtuosoStyles={{
      height: selectedResources.length ? props.initialFilterMode === "key-value" ? "226px" : "270px" : props.initialFilterMode === "key-value" ? "286px" : "330px",
      marginRight: "-24px",
      paddingRight: "24px"
    }} />;
    $[53] = options;
    $[54] = props;
    $[55] = selectedResources.length;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== t16 || $[58] !== t18 || $[59] !== t19) {
    t20 = <Box className="overflow-auto px-[24px] py-[12px]" onScroll={t16} sx={t17}>{t18}{t19}</Box>;
    $[57] = t16;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== isLoading || $[62] !== t15 || $[63] !== t20 || $[64] !== t9) {
    t21 = <SelectionPanel isLoading={isLoading} drawerProps={t9}>{t15}{t20}</SelectionPanel>;
    $[61] = isLoading;
    $[62] = t15;
    $[63] = t20;
    $[64] = t9;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  return t21;
};
function _temp(acc, tag_0) {
  acc.keys.add(tag_0.key);
  if (tag_0.value) {
    acc.values.add(tag_0.value);
  }
  return acc;
}
function _temp2(key_1) {
  return {
    id: key_1,
    name: key_1
  };
}
function _temp3(value_1) {
  return {
    id: value_1,
    name: value_1
  };
}
function _temp4(x_0) {
  return `${x_0.key}=${x_0.value || ""}`;
}
function _temp5(value_2) {
  return {
    id: value_2,
    name: value_2
  };
}
function _temp6(item_0) {
  return <Typography>{item_0}</Typography>;
}
function _temp7(item_1) {
  return item_1;
}